<a [attr.href]="buttonTarget" class="master-banner d-flex w-100 text-decoration-none">
  <ng-container [ngSwitch]="bannerSize.toLowerCase()">
    <ng-container *ngSwitchCase="bannerSizeType.XS" [ngTemplateOutlet]="bannerXs"></ng-container>
    <ng-container *ngSwitchCase="bannerSizeType.LG" [ngTemplateOutlet]="bannerLg"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="bannerMd"></ng-container>
  </ng-container>

  <ng-template #bannerXs>
    <div class="master-banner-xs d-flex flex-row bl-h-7 ps-3 w-100">
      <div class="xs-headline-wrapper w-100 d-flex">
        <span class="heading-sm text-uppercase truncate-3 text-primary pb-0 align-self-center">
          {{ mobileHeadline }}
        </span>
      </div>
      <div [ngClass]="isLifestyle ? 'indent-margin img-gradient' : 'xs-img-wrapper ps-1 pe-3'" class="d-flex">
        <shrd-uic-image
          [containerClass]="isLifestyle && 'image-container-cover'"
          [src]="imageUrl"
          [usePlaceholder]="true"
        ></shrd-uic-image>
      </div>
    </div>
  </ng-template>

  <ng-template #bannerMd>
    <div class="master-banner-med w-100 d-flex flex-column">
      <div [ngClass]="{ 'px-3 pt-3': !isLifestyle }" class="d-flex bl-h-13 flex-shrink-0">
        <shrd-uic-image
          [containerClass]="isLifestyle && 'image-container-cover'"
          [src]="imageUrl"
          [usePlaceholder]="true"
        ></shrd-uic-image>
      </div>
      <div class="px-3 pt-1 d-flex flex-column h-100">
        <div class="banner-content">
          <div *ngIf="bannerOverline" class="overline">
            <sub class="compressed-bold truncate-1 py-0 banner-text-dark">{{ bannerOverline }}</sub>
          </div>
          <div>
            <span class="heading-md mb-0 text-primary text-uppercase truncate-3">{{ bannerHeadline }}</span>
          </div>
          <div *ngIf="bannerSubline">
            <p class="text-secondary truncate-2 mb-0 text-bold">{{ bannerSubline }}</p>
          </div>
          <div *ngIf="bannerBodyText" class="d-flex">
            <p class="truncate-3 my-0 banner-text-dark">{{ bannerBodyText }}</p>
          </div>
        </div>
        <div class="d-flex mt-auto">
          <span class="w-100 btn btn-secondary text-uppercase">
            <span>
              {{ buttonText }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #bannerLg>
    <div [ngClass]="{ 'pe-sm-3': !isLifestyle }" class="master-banner-lg d-flex pe-0 flex-row w-100">
      <div
        [ngClass]="!isLifestyle && 'product-img-gradient'"
        class="w-100 d-flex pb-1 pt-1 pt-lg-2 px-3 pe-sm-0 content-container"
      >
        <div class="d-flex flex-column content-wrapper w-100">
          <span class="heading-md truncate-2 truncate-md-1 text-uppercase text-primary mb-0">
            {{ bannerHeadline }}
          </span>
          <div *ngIf="bannerSubline" class="subline-text">
            <p class="text-secondary truncate-1 text-bold" [ngClass]="bannerBodyText ? 'mb-1' : 'mb-0'">
              {{ bannerSubline }}
            </p>
          </div>
          <div *ngIf="bannerBodyText" class="d-flex body-text">
            <p class="truncate-2 mb-0">{{ bannerBodyText }}</p>
          </div>
          <div class="d-flex">
            <span class="my-0" shrdUicButton variant="tertiaryTrivialTextBold">
              <span class="d-inline">{{ buttonText }}</span>
              <shrd-uic-svg-icon [icon]="iconsSet.ARROW_RIGHT" class="ms-0" size="small"></shrd-uic-svg-icon>
            </span>
          </div>
        </div>
      </div>
      <div
        [ngClass]="isLifestyle ? 'indent-margin lifestyle-img-gradient' : 'py-2 ps-3 img-product'"
        class="img-wrapper d-none d-sm-flex w-100 w-md-50 w-lg-25"
      >
        <shrd-uic-image
          [containerClass]="isLifestyle ? 'image-container-cover position-absolute' : 'position-absolute w-100'"
          [src]="imageUrl"
          [usePlaceholder]="true"
          class="d-block position-relative"
        ></shrd-uic-image>
      </div>
    </div>
  </ng-template>
</a>
